import { CommonModule } from '@angular/common';
import {
    Component,
    EventEmitter,
    inject,
    input,
    OnInit,
    Output,
    Signal,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
    MatDialog,
    MatDialogModule,
    MatDialogRef,
} from '@angular/material/dialog';
import { IIqMcModalMci } from '../models';
import { IqMcModalStateService } from '../state';

@Component({
    selector: 'iq-mc-modal-mci',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatDialogModule],
    templateUrl: './iq-mc-modal-mci.component.html',
    styleUrl: './iq-mc-modal-mci.component.scss',
})
export class IqMcModalComponent implements OnInit {
    settings: IIqMcModalMci;

    readonly dialog = inject(MatDialog);

    id: Signal<string> = input<string>('');

    @Output()
    closed: EventEmitter<void> = new EventEmitter<void>();
    constructor(
        private _state: IqMcModalStateService,
        private dialogRef: MatDialogRef<IqMcModalComponent>,
    ) {}

    ngOnInit(): void {
        this.settings = this._state.mapMciModalSettings();
    }

    close(): void {
        this.dialogRef.close();
    }
}
